// extracted by mini-css-extract-plugin
export default {"button":"mOdzvhUbAJrDiJL0d9sZ","iconWrapper":"KQFnUJGeTc_I0ybGDlSa","left":"_0T5KVWeFlQ0UJ4Z0erH","submit":"fCNtOnCuvfmrJzJ3q_SQ","reset":"Dcnt7HGOuE0eTwCn_WVV"};